<div class="header" [class.header--guest]="!userState.user()">
  <div class="header__container">
    <div class="header__left">
      <div
        (clickOutside)="menuMobileOpen.set(false)"
        [clickOutsideEnabled]="menuMobileOpen()"
        class="header__menu-container">
        <icon-button
          [icon]="MenuOutline"
          class="header__menu"
          (click)="toggleMenuMobile()" />
        @if (menuMobileOpen()) {
          <sidebar-mobile
            [userImage]="userImage()"
            [userName]="userName()"
            [userEmail]="userEmail()"
            side="left"
            class="header__menu-mobile" />
        }
      </div>
      <a [href]="routes.HOME" class="header__logo">
        <img [alt]="seoAuthor" />
      </a>
      <a [href]="routes.HOME" class="header__logo header__logo--mobile">
        <img [alt]="seoAuthor" />
      </a>

      <nav class="header__navigation">
        <nav-item [routerLink]="routes.COURSES" label="Cursos" />
        <nav-item [routerLink]="routes.ABOUT_US" label="Nosotros" />
        <nav-item
          [activeOptions]="{ exact: false }"
          [routerLink]="routes.CERTIFICATES_VALIDATE"
          label="Validar Certificado" />
      </nav>
    </div>

    <div class="header__right">
      <dropdown-form-control
        [icon]="DollarCircleBold"
        [options]="currencyOptions"
        [value]="currentCode()"
        (valueChange)="setCurrency($event)"
        class="header__currency-dropdown" />
      <icon-button
        [badgeCount]="cartState.itemCount()"
        [routerLink]="routes.CART"
        [icon]="ShoppingCartOutline"
        variant="color"
        class="header__cart" />

      <icon-button
        [icon]="iconTheme()"
        (click)="setDarkMode(!darkMode())"
        variant="color"
        class="header__dark-mode-toggle" />
      @if (userState.user(); as user) {
        <div
          (clickOutside)="sidebarMobileOpen.set(false)"
          [clickOutsideEnabled]="sidebarMobileOpen()"
          class="header__avatar-container">
          <avatar
            (click)="toggleSidebarMobile()"
            [name]="userName()!"
            [src]="userImage()"
            shape="circle"
            size="md"
            class="header__avatar" />

          @if (sidebarMobileOpen()) {
            <sidebar-mobile
              [userImage]="userImage()"
              [userName]="userName()"
              [userEmail]="userEmail()"
              class="header__sidebar-mobile" />
          }
        </div>
      } @else {
        @if (loginButton === 'animated') {
          <primary-animated-button
            [routerLink]="routes.AUTH_LOGIN"
            [queryParams]="{ redirect: authState.redirect() }"
            class="header__login"
            label="Acceder" />
        } @else {
          <primary-button
            [routerLink]="routes.AUTH_LOGIN"
            [queryParams]="{ redirect: authState.redirect() }"
            [variant]="asPrimaryVariant(loginButton)"
            class="header__login"
            label="Acceder" />
        }
        @if (registerButton === 'animated') {
          <primary-animated-button
            [routerLink]="routes.AUTH_REGISTER"
            [queryParams]="{ redirect: authState.redirect() }"
            class="header__register"
            label="Registrarme" />
        } @else {
          <primary-button
            [routerLink]="routes.AUTH_REGISTER"
            [queryParams]="{ redirect: authState.redirect() }"
            [variant]="asPrimaryVariant(registerButton)"
            class="header__register"
            label="Registrarme" />
        }
      }
    </div>
  </div>
</div>
